import React, { useEffect, useRef, useState } from 'react';
import ApiService from '../../../../services/apiService';
import '../report.css';
import Select from 'react-select';
import { Modal } from 'react-bootstrap';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';
import Logo from '../../../../assets/images/Pro_Logo.png';
const ZReport = () => {
  const [groupedData, setGroupedData] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [companyLogo, setCompanyLogo] = useState(Logo);

  useEffect(() => {
    try {
      const raw = localStorage.getItem('userCompanies');
      const companies = raw ? JSON.parse(raw) : [];

      const logoUrl = companies?.[0]?.logo;
      if (logoUrl) setCompanyLogo(logoUrl);
    } catch (e) {
      // keep fallback if parsing fails
      setCompanyLogo(Logo);
    }
  }, []);
  // ✅ Branch dropdown
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const navigate = useNavigate();
  const printRef = useRef();

  // ✅ for <input type="date" />
  const dateToInputValue = (d) => new Date(d).toISOString().slice(0, 10);

  const today = new Date();

  // ✅ Only ONE date: ReportDate
  const [formData, setFormData] = useState({
    reportDate: dateToInputValue(today),
  });

  const handleInputChange = (e) => {
    setFormData((p) => ({ ...p, [e.target.name]: e.target.value }));
  };

  // ✅ Fetch branches (same as sale report)
  const fetchBranches = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_BRANCH');
      const list = res?.data?.result || [];

      setBranches(
        list.map((b) => ({
          value: b.id,
          label: b.branchName,
        })),
      );
    } catch (error) {
      console.error('Branch Load Error: ', error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  // ✅ ONLY ReportDate + BranchId (from dropdown)
  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();

      // backend expects: ReportDate + BranchId
      params.append('ReportDate', `${formData.reportDate} 00:00:00`); // add time to match backend format
      params.append('BranchId', selectedBranch?.value || 0); // 0 = all branches
      params.append('PageNo', 1); // 0 = all branches
      params.append('PageSize', 100); // 0 = all branches

      const res = await apiService.getApiParamater('GET_Z_REPORT', `?${params.toString()}`);

      const result = Array.isArray(res?.data?.result) ? res.data.result : [];

      const grouped = result.reduce((acc, curr) => {
        const key = curr.section || 'Unknown';
        if (!acc[key]) acc[key] = [];
        acc[key].push(curr);
        return acc;
      }, {});

      setGroupedData(grouped);
      setIsModalVisible(true);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlePrint = async () => {
    if (!printRef.current) return;

    const canvas = await html2canvas(printRef.current, { scale: 3 });
    const imgData = canvas.toDataURL('image/png');

    const pdf = new jsPDF({
      orientation: 'p',
      unit: 'px',
      format: 'a4',
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = pdf.internal.pageSize.getHeight();

    const imgWidth = pdfWidth;
    const imgHeight = (canvas.height * pdfWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pdfHeight;

    while (heightLeft > 0) {
      position -= pdfHeight;
      pdf.addPage();
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
    }

    pdf.save('Z-Report.pdf');
  };

  return (
    <div className="p-5">
      <button className="addItem-btn mb-3" onClick={() => navigate(-1)}>
        ← Back
      </button>

      {/* ✅ Filters: Report Date + Branch */}
      <div className="row g-3 align-items-end">
        <div className="col-12 col-md-4">
          <label className="form-label">Report Date</label>
          <input type="date" className="form-control" value={formData.reportDate} onChange={handleInputChange} name="reportDate" />
        </div>

        <div className="col-12 col-md-4">
          <label className="form-label">Select Branch</label>
          <Select
            value={selectedBranch}
            onChange={setSelectedBranch}
            options={branches}
            placeholder="Select Branch"
            isClearable
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              menu: (base) => ({ ...base, zIndex: 999999 }),
            }}
          />
        </div>

        <div className="col-12 col-md-4">
          <div className="refbtn center w-100 mt-1" onClick={getReportData}>
            Search
          </div>
        </div>
      </div>

      {/* ✅ Report Modal */}
      <Modal show={isModalVisible} onHide={() => setIsModalVisible(false)} centered>
        <Modal.Header>
          <div className="receipt-logo center">Z Report</div>
        </Modal.Header>

        <Modal.Body>
          <div ref={printRef}>
            <div className="receipt-container">
              <div className="receipt-header">
                <img src={companyLogo} alt="Company Logo" style={{ maxWidth: '150px', maxHeight: '80px' }} className="receipt-logo" />
                <div className="receipt-date">{new Date().toLocaleDateString('en-GB')}</div>
              </div>

              {Object.keys(groupedData).length === 0 && <div className="text-center text-muted py-3">No data found</div>}

              {Object.entries(groupedData).map(([sectionName, items]) => (
                <div key={sectionName} className="section-block">
                  <div className="section-title">{String(sectionName).toUpperCase()}</div>
                  <hr />
                  {items.map((item, index) => (
                    <div key={index} className="receipt-row">
                      <span>{item?.detail || '-'}</span>
                      <span>{Number(item?.amount ?? 0).toFixed(2)}</span>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div onClick={handlePrint} className="refbtn">
            Print PDF
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ZReport;
